"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var userManager_1 = require("../../userManager/userManager");
/**
 * Component to show once user is logged out.
 * @param autoRenew
 * If true, signin process will take place. If false, it will display custom component.
 * @param component
 * Displays custom component for logged out user.
 * @param loadingComponent
 * What loading component to show while signin process is taking place. Will only show if autoRenew is true.
 */
exports.LoggedOutComponent = function (_a) {
    var autoRenew = _a.autoRenew, component = _a.component, loadingComponent = _a.loadingComponent;
    var Loader = loadingComponent;
    var CustomComponent = component;
    var DefaultComponent = function () { return react_1.default.createElement("div", null, "You are now logged out. You can provide a custom view by passing in a component through the component prop"); };
    var userManager = userManager_1.UserManager.getInstance();
    if (autoRenew) {
        userManager.signinRedirect();
        return Loader ? react_1.default.createElement(Loader, null) : react_1.default.createElement("p", null, "Loading....");
    }
    else {
        return CustomComponent ? react_1.default.createElement(CustomComponent, null) : react_1.default.createElement(DefaultComponent, null);
    }
};
//# sourceMappingURL=LoggedOutComponent.js.map